module.exports = __webpack_public_path__ + "img/bmw.svg";